(function() {

  angular
  .module('meanApp')
  .factory('Recipe', Recipe);

  Recipe.$inject = [
        '$http', 
        'httpAuth', 
        '$rootScope', 
        'Model', 
        '$q', 
        'ingredientsManager', 
        'usersManager',
        'currentUser'];
  function Recipe (
        $http, 
        httpAuth, 
        $rootScope, 
        Model, 
        $q, 
        ingredientsManager, 
        usersManager,
        currentUser) {
    var Recipe = function (recipeData) {
        //here check for ingredients and create subobjects
        var ingredient;

        if(recipeData && Array.isArray(recipeData.ingredientsQuantity)) {    
            recipeData.ingredientsQuantity.forEach(function(ingredientQuantity) {
                ingredient = ingredientQuantity.ingredient;
                
                if (ingredient && ingredient.slug) {
                    ingredientQuantity.ingredient = ingredientsManager._retrieveInstance(ingredient.slug, ingredient);
                }
            });
        }

        //put author in usermanager
        if(recipeData && recipeData.author) {
            recipeData.author = usersManager._retrieveInstance(recipeData.author._id, recipeData.author);
        }

        if(recipeData && recipeData.monthsSoldInFrance) {
            if(recipeData.monthsSoldInFrance.indexOf(new Date().getMonth()) > -1) {
                recipeData.tags.push('season');
            }
        }
 
        Model.apply(this, arguments);
    };

    Recipe.APIPath = 'recipes';
    Recipe.idAttribute = 'slug';
    Recipe.prototype = {
        //used after a put ?
        /**setData: function(recipeData) {
            var ingredient;

            if(recipeData && Array.isArray(recipeData.ingredientsQuantity)) {    
                recipeData.ingredientsQuantity.forEach(function(ingredientQuantity) {
                    ingredient = ingredientQuantity.ingredient;
                    if (ingredient && ingredient.slug) {
                        ingredientQuantity.ingredient = ingredientsManager._retrieveInstance(ingredient.slug, ingredient);
                    }
                });
            }
            Model.apply(this, arguments);
        },**/

        //do not update it since we don't want to have non complete data.
        setDataOverrided : function(data) {
            if(data.isDraft === false) {
                var firstIngredient = data.ingredientsQuantity[0],
                firstAllergen = data.allergensRisk && data.allergensRisk.length > 0 && data.allergensRisk[0];

                if (typeof firstIngredient.ingredient === 'string') {
                    delete data.ingredientsQuantity;
                }

                if(firstAllergen && typeof firstAllergen.allergen === 'string'){
                    delete data.allergensRisk;
                }
            }
            console.log('object overrided', this, data);
            angular.extend(this, data);
        },

        //puts here the necessary stuff
        isModelComplete : function() {
            var isModelComplete = false;
            if(this.isDraft === false) {
                var firstIngredient = this.ingredientsQuantity && this.ingredientsQuantity[0];
                if(firstIngredient && firstIngredient.ingredient && firstIngredient.ingredient.name) {
                    isModelComplete = true;
                }
            }
            return isModelComplete;
        },

        like: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.post('/api/users/'+$rootScope.currentUser._id +'/'+ Recipe.APIPath + '/' + this._id+'/likes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        unlike: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.delete('/api/users/'+$rootScope.currentUser._id +'/'+ Recipe.APIPath + '/' + this._id+'/likes', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        bookmark: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.post('/api/users/'+$rootScope.currentUser._id +'/'+ Recipe.APIPath + '/' + this._id+'/bookmarks', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function() {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        unbookmark: function() {
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.delete('/api/users/'+$rootScope.currentUser._id +'/'+ Recipe.APIPath + '/' + this._id+'/bookmarks', {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function() {
                console.log('the api like on ingredient succeeded');
            })
            .error(function() {
                console.log('the api like on ingredient failed');
            });
        },

        getInteractions: function() {
            var deferred = $q.defer(),
            url = '',
            that = this;
            //step 1 get the id of current user
            //step 2 perform the call
            currentUser.get().then(function(userModel) {
                //2 different APIs requested according to user connection or not
                url = userModel._id ? ('/api/users/'+userModel._id +'/'+ Recipe.APIPath + '/' + that._id+'/interactions') : ('/api/'+ Recipe.APIPath + '/' + that._id+'/interactions'); 
                httpAuth.get(url, {}, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .success(function(result) {
                    deferred.resolve(result);
                })
                .error(function(err) {
                    deferred.reject(err);
                });
            });

            return deferred.promise;
        },

        getAPIPath: function() {
            return Recipe.APIPath;
        },
        getIdAttribute : function() {
            return Recipe.idAttribute;
        },
        saveAsDraft : function(formData) {
            var deferred = $q.defer(),
            scope = this;
            
            httpAuth.post('/api/'+this.getAPIPath()+'/', formData, {
                headers: {'Content-Type': undefined }
            })
            .success(function(result) {
                //TODO merge the result and everything ?
                var resultSubset = {};
                if(result._id) {
                    resultSubset._id = result._id;
                }
                if(result.slug) {
                    resultSubset.slug = result.slug;
                }
                if(result.recipeFilePath) {
                    resultSubset.recipeFilePath = result.recipeFilePath;
                }
                this.setData(resultSubset);
                deferred.resolve(this);
            }.bind(this))
            .error(function(err) {
                console.log('JS front end success for saving recipe');
                deferred.reject(err);
            });
            return deferred.promise;
        },
        //there is not always a picture in the request !!
        updateWithPicture : function(formData) {
            var deferred = $q.defer(),
            scope = this;
            
            httpAuth.put('/api/'+this.getAPIPath()+'/'+this._id, formData, {
                headers: {'Content-Type': undefined }
            })
            .success(function(data) {
                //TODO merge the result and everything ?
                //just merge slug _id and the recipeFilePath
                this.setData(data);
                deferred.resolve(this);
            }.bind(this))
            .error(function(err) {
                console.log('JS front end success for saving recipe');
                deferred.reject(err);
            });
            return deferred.promise;
        },

        getThumb : function (size) {
            var ans = 'undefined';
            if(this._id) {
                ans = 'api/thumb/'+this.getAPIPath()+'/'+this._id+'/size/'+size+'/update/'+new Date(this.updatedAt).getTime();
            }
            return ans;
        },

        getCreationDate : function() {
            //TODO one day convert this in other languages
            return new Date(this.createdAt).toLocaleString('fr-FR');
        },

        getTextualUnkownIngredients: function() {
            var text = '';
            this.unknownIngredientsQuantity.forEach(function(unknownIngredientQuantity) {
                text+= text.length > 0 ? (', ' + unknownIngredientQuantity.ingredient) : unknownIngredientQuantity.ingredient;
            }); 
            return text;
        },

        getPriceLevel: function() {
            //here compute the percentage, use log to improve the way we see difference between prices
            //let's assume that 50 euros per kilo is the maximum
            //take the log + 1 so only positive values
            // 0 euro --> would give 0 euro
            // 50 euro --> would give 3.93 maximum
            var MAX_VALUE = 3.93,
            color = blueLevel5,
            valueAfterLog = Math.min(Math.log(Math.max(this.pricePerKilo, 1)), MAX_VALUE),
            percentage = 100 * (valueAfterLog/MAX_VALUE),
            blueLevel1 = '#cce6ff',
            blueLevel2 = '#89bff8',
            blueLevel4 = '#165b93',
            blueLevel5 = '#012951';

            if(percentage < 75 && percentage >=50) {
                color = blueLevel4;
            }
            else if (percentage < 50 && percentage >= 25){
                color = blueLevel2;
            }
            else if (percentage < 25) {
                color = blueLevel1;
            }
            //Display
            return {
                'background-color': color, 
                'width' : percentage+'%'
            };
        }
    };
    
    angular.extend(Recipe.prototype, Model.prototype);

    return Recipe;
  };

})();